var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [_vm._v(" Filters ")]),
            _c(
              "button",
              {
                staticClass: "button is-pulled-right is-small is-turquoise",
                on: { click: _vm.gotoV1 },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-arrow-right" }),
                ]),
                _c("span", [_vm._v("V1")]),
              ]
            ),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c("li", [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value.invoiceNo,
                        expression: "value.invoiceNo",
                      },
                    ],
                    staticClass: "input is-capitalized",
                    attrs: { type: "text", placeholder: "Invoice No." },
                    domProps: { value: _vm.value.invoiceNo },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onFilterClick()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.value, "invoiceNo", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value.debtor,
                        expression: "value.debtor",
                      },
                    ],
                    staticClass: "input is-capitalized",
                    attrs: { type: "text", placeholder: "Debtor" },
                    domProps: { value: _vm.value.debtor },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onFilterClick()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.value, "debtor", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value.quoteNo,
                        expression: "value.quoteNo",
                      },
                    ],
                    staticClass: "input is-capitalized",
                    attrs: { type: "text", placeholder: "Quote No." },
                    domProps: { value: _vm.value.quoteNo },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onFilterClick()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.value, "quoteNo", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.filterType,
                      expression: "value.filterType",
                    },
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    checked: "",
                    id: "nonzerobalance",
                    type: "radio",
                    name: "FilterType",
                    value: "1",
                  },
                  domProps: { checked: _vm._q(_vm.value.filterType, "1") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.value, "filterType", "1")
                    },
                  },
                }),
                _c("label", { attrs: { for: "nonzerobalance" } }, [
                  _vm._v("Invoices with Non-Zero Balance Only"),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.filterType,
                      expression: "value.filterType",
                    },
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    id: "lastsixmonth",
                    type: "radio",
                    name: "FilterType",
                    value: "2",
                  },
                  domProps: { checked: _vm._q(_vm.value.filterType, "2") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.value, "filterType", "2")
                    },
                  },
                }),
                _c("label", { attrs: { for: "lastsixmonth" } }, [
                  _vm._v("All Invoices within Last 6 Months"),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.filterType,
                      expression: "value.filterType",
                    },
                  ],
                  staticClass: "is-checkradio",
                  attrs: {
                    id: "allinvoice",
                    type: "radio",
                    name: "FilterType",
                    value: "0",
                  },
                  domProps: { checked: _vm._q(_vm.value.filterType, "0") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.value, "filterType", "0")
                    },
                  },
                }),
                _c("label", { attrs: { for: "allinvoice" } }, [
                  _vm._v("All Invoices"),
                ]),
              ]),
            ]),
          ]),
          _c("hr"),
          _c("div", { staticClass: "field is-grouped is-pulled-right" }, [
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  on: { click: _vm.onFilterClick },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Filter")]),
                ]
              ),
            ]),
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                { staticClass: "button", on: { click: _vm.onResetClick } },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Reset")]),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }